<!-- <div  *ngIf="getMessages().length > 0 &&  getMessages()[0].detail && getMessages()[0].detail.length > 0"><p-messages *ngIf="!hideBlurb" [styleClass]="'cats-blurp'" [value]="getMessages()" [escape]="false"></p-messages>
</div> -->

<div
  *ngIf="
    getMessages()?.length > 0 &&
    getMessages()[0]?.detail &&
    getMessages()[0].detail.length > 0
  "
>
  <ng-container *ngIf="!hideBlurb">
    <p-message
      *ngFor="let m of getMessages()"
      [styleClass]="'cats-blurp'"
      [severity]="m.severity"
      [text]="m.detail || m.summary"
      [escape]="false"
      [closable]="true"
    ></p-message>
  </ng-container>
</div>